import { _keys, cloneObj, Debounce, exists, mergeObject, Module, Second } from '@nu-art/ts-common';
import { ModuleFE_EMInterface } from '../../_entity/runtime/em-interface/ModuleFE_EMInterface.js';
import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend';
import { ABTestValue } from '@app/org-shared';
const dispatch_OnPractitionerConfigUpdated = new ThunderDispatcher('__onPractitionerConfigUpdated');
class ModuleFE_AdvisorState_Class extends Module {
    practitionerConfig;
    debounce_UpdateConfig = new Debounce(() => this.updatePractitionerConfig_Impl(), 1 * Second, 5 * Second);
    constructor() {
        super();
        this.practitionerConfig = this.getDefaultPractitionerConfig();
    }
    //######################### Internal Logic #########################
    getDefaultPractitionerConfig = () => {
        return {
            collapsing: {
                homePanel: {
                    hpi: true,
                    cc: true,
                    history: true,
                    ddx: undefined,
                    pertinentData: undefined,
                }
            },
            abTesting: {
                magicWand: undefined,
                catchUp_recap: undefined,
                catchUp_vitals: undefined,
                pertinentData: undefined,
            }
        };
    };
    updatePractitionerConfig_Impl = async () => {
        const uiState = this.practitionerConfig;
        if (!uiState)
            return;
        try {
            await ModuleFE_EMInterface.vv1.advisorUtils.setPractitionerConfig({ uiState }).executeSync();
            this.logDebug('Updated UI state');
        }
        catch (err) {
            this.logError('Failed to update UI state', err);
        }
    };
    //######################### Interface #########################
    setProperties = (config) => {
        if (!config)
            return;
        this.practitionerConfig = mergeObject(this.practitionerConfig, config);
        if (!ModuleFE_EMInterface.isAvatarMode())
            this.debounce_UpdateConfig.trigger();
        dispatch_OnPractitionerConfigUpdated.dispatchUI();
    };
    setABTestingDefaults = (config) => {
        if (!config)
            return;
        const abTestConfig = cloneObj(this.practitionerConfig.abTesting);
        _keys(config).forEach(key => {
            if (exists(this.practitionerConfig.abTesting[key]))
                return;
            switch (config[key]) {
                case ABTestValue.Enabled_DefaultFalse:
                    abTestConfig[key] = false;
                    break;
                case ABTestValue.Enabled_DefaultTrue:
                    abTestConfig[key] = false;
                    break;
            }
        });
        this.setProperties({ abTesting: abTestConfig });
    };
    setProperty = {
        collapsing: {
            homePanel: {
                hpi: (value) => this.setProperties({ collapsing: { homePanel: { hpi: value } } }),
                cc: (value) => this.setProperties({ collapsing: { homePanel: { cc: value } } }),
                history: (value) => this.setProperties({ collapsing: { homePanel: { history: value } } }),
                ddx: (value) => this.setProperties({ collapsing: { homePanel: { ddx: value } } }),
                pertinentData: (value) => this.setProperties({ collapsing: { homePanel: { pertinentData: value } } }),
            }
        },
        abTesting: {
            magicWand: value => this.setProperties({ abTesting: { magicWand: value } }),
            catchUp_recap: value => this.setProperties({ abTesting: { catchUp_recap: value } }),
            catchUp_vitals: value => this.setProperties({ abTesting: { catchUp_vitals: value } }),
            pertinentData: value => this.setProperties({ abTesting: { pertinentData: value } }),
        },
    };
    getStateProperty = {
        collapsing: {
            homePanel: {
                hpi: () => this.practitionerConfig?.collapsing?.homePanel?.hpi,
                cc: () => this.practitionerConfig?.collapsing?.homePanel?.cc,
                history: () => this.practitionerConfig?.collapsing?.homePanel?.history,
                ddx: () => this.practitionerConfig?.collapsing?.homePanel?.ddx,
                pertinentData: () => this.practitionerConfig?.collapsing?.homePanel?.pertinentData,
            }
        },
        abTesting: {
            magicWand: () => this.practitionerConfig?.abTesting?.magicWand,
            catchUp_recap: () => this.practitionerConfig?.abTesting?.catchUp_recap,
            catchUp_vitals: () => this.practitionerConfig?.abTesting?.catchUp_vitals,
            pertinentData: () => this.practitionerConfig?.abTesting?.pertinentData,
        },
    };
}
export const ModuleFE_AdvisorState = new ModuleFE_AdvisorState_Class();
//# sourceMappingURL=ModuleFE_AdvisorState.js.map